/** Google's review box for a listing. The link is permanent, so it is safe to print. */
const googleReviewUrl = (placeId: string): string => `https://search.google.com/local/writereview?placeid=${placeId}`;

const parseFacebookUrl = (pageUrl: string): URL | null => {
  const trimmed = pageUrl.trim();
  const address = /^https?:\/\//iu.test(trimmed) ? trimmed : `https://${trimmed}`;
  if (!URL.canParse(address)) {
    return null;
  }
  const url = new URL(address);
  if (url.hostname === "facebook.com" || url.hostname.endsWith(".facebook.com")) {
    return url;
  }
  return null;
};

/** The reviews tab of a Facebook page, or null when the address isn't a Facebook page. */
const facebookReviewUrl = (pageUrl: string): string | null => {
  const url = parseFacebookUrl(pageUrl);
  if (url === null) {
    return null;
  }
  // Pages without a username live at profile.php?id=…, where the tab is a query parameter.
  if (url.pathname.endsWith("/profile.php")) {
    url.searchParams.set("sk", "reviews");
    return url.href;
  }
  const pagePath = url.pathname.replace(/(?:\/reviews)?\/*$/u, "");
  if (pagePath === "") {
    return null;
  }
  return `https://www.facebook.com${pagePath}/reviews`;
};

export { facebookReviewUrl, googleReviewUrl };
